const state = {
  lotteryfrom: {
    app_id: null,
    prize_name: "",
    prize_type: 1,
    start_time: "",
    end_time: "",
    team_title: "",
    team_statement: "",
    share_statement: "",
    share_title: "",
    share_pic_url: "",
    team_pic_url: "",
    population_type: 1,
    population_member_ids: [],
    population_level_ids: [],
    population_tag_ids: [],
    slogan: "",
    max_share_num: 1,
    pic_url:
      "https://prd-1258898587.cos.ap-beijing.myqcloud.com/public/2021/02/02/11/a1d78decc2abd9252ecd09a97547.png",
    is_share: 0,
    share_add_num: 1,
    is_team: 0,
    team_time_type: 1,
    team_people_num: 3,
    team_add_num: 1,
    team_max_num: 1,
    is_free: false,
    free_num: null,
    is_consume: false,
    consume_type: 1,
    consume_products: [
      {
        goods_ids: "",
        quota_type: 1,
        quota: 1,
        num: 1
      }
    ],
    is_consume_card_recharge: false,
    consume_card_recharge_type: 1,
    consume_card_recharge_cards: [
      {
        goods_ids: "",
        quota_type: 1,
        quota: 1,
        num: 1
      }
    ],
    is_consume_card_consume: false,
    is_display: true,
    consume_card_consume_type: 1,
    consume_card_consume_cards: [
      {
        goods_ids: "",
        quota_type: 1,
        quota: 1,
        num: 1
      }
    ],
    is_integral: false,
    integral_num: null,
    intro_type: 1,
    intro: "",
    award_num: 1,
    awards: []
  }
};

const mutations = {
  SET_LOTTERY(state, lotteryfrom) {
    state.lotteryfrom = lotteryfrom;
  },
  SET_INIT(state, lotteryfrom) {
    state.lotteryfrom = lotteryfrom;
  }
};
const actions = {
  SETLOTTERY({ commit }, form) {
    commit("SET_LOTTERY", form);
  },
  SETINIT({ commit }) {
    commit("SET_INIT", {
      app_id: null,
      prize_name: "",
      prize_type: 1,
      start_time: "",
      end_time: "",
      population_type: 1,
      population_member_ids: [],
      population_level_ids: [],
      population_tag_ids: [],
      slogan: "",
      max_share_num: 1,
      pic_url:
        "https://prd-1258898587.cos.ap-beijing.myqcloud.com/public/2021/02/02/11/a1d78decc2abd9252ecd09a97547.png",
      is_share: 0,
      share_add_num: 1,
      is_team: 0,
      team_time_type: 1,
      team_people_num: 3,
      team_add_num: 1,
      team_max_num: 1,
      is_free: false,
      free_num: null,
      is_consume: false,
      consume_type: 1,
      consume_products: [
        {
          goods_ids: "",
          quota_type: 1,
          quota: 1,
          num: 1
        }
      ],
      is_consume_card_recharge: false,
      is_display: true,
      consume_card_recharge_type: 1,
      consume_card_recharge_cards: [
        {
          goods_ids: "",
          quota_type: 1,
          quota: 1,
          num: 1
        }
      ],
      is_consume_card_consume: false,
      consume_card_consume_type: 1,
      consume_card_consume_cards: [
        {
          goods_ids: "",
          quota_type: 1,
          quota: 1,
          num: 1
        }
      ],
      is_integral: false,
      integral_num: null,
      intro_type: 1,
      intro: "",
      award_num: 1,
      awards: []
    });
  }
};

export default {
  state,
  mutations,
  actions
};
